import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]
  static values = { delay: { type: Number, default: 300 } }

  connect() {
    this.timer = null
  }

  search() {
    window.clearTimeout(this.timer)
    this.timer = window.setTimeout(() => {
      this.element.requestSubmit()
    }, this.delayValue)
  }
}
